import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {jobApplicationsView_template} from "../components/templates/jobApplicationsView_template";
import {is} from "@amcharts/amcharts4/core";

declare var ko: any;
declare var page: any;

const REQUIRED_QUESTION_IDS: number[] = [2, 3];

export class job_applications_view extends vnModule_knockoutJS{

    protected viewForm: jobApplicationsView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string{

        return "job_applications_view";
    }

    buildContent(): Array<Element>{

        this.viewForm = new jobApplicationsView_template("view_template", this.viewModel, this);

        //only show Add Job Profile button if CM or Admin
        let vnApp = this.getVnAppZone().app;
        let roles = vnApp.loggedUser.user.valnet_user.roles;
        for(let r of roles ){
            //if candidate(20) or Admin(1)
            if( r.id == 1 || r.id == 20){
                this.viewForm.setIsEditButtonShown(true);
            }
        }
        return [this.viewForm.build()];
    }

    public fillPage(): void{

        this.getApplication();
    }

    protected getApplication(){

        // LOADING : starts
        this.loadingIn(this.viewForm.builtTemplate);

        let usrReq_url: string = '/api/job/applications/get/'+ this.getVnAppZone().app.params.id;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let permissions = responseParsed.permissions
                let internalNotes = responseParsed.internalNotes
                let applicationHistory = responseParsed.applicationHistory
                let offboardingHistory = responseParsed.offboardingHistory

                let rejectionReasons = responseParsed.rejectionReasons

                obj.viewForm.setConfigOptions(responseParsed.configOptions || []);
                obj.setUpForm(responseParsed.data, permissions, internalNotes,rejectionReasons,applicationHistory,offboardingHistory);
            });

            obj.loadingOut(obj.viewForm.builtTemplate);
        }
    }

    protected setUpForm(data, permissions, internalNotes,rejectionReasons,applicationHistory,offboardingHistory): void{

        let vnApp = this.getVnAppZone().app;
        this.viewForm.setIdLoggedUser(vnApp.loggedUser.user.id);

        this.viewForm.setId(data.id);
        this.viewForm.setCandidateName(data.fullName);
        this.viewForm.setCandidateEmail(data.email);
        this.viewForm.setPositionTitle(data.originalProfile.name);
        this.viewForm.setResume(data.resume ? data.resume : null);
        this.viewForm.setResumeFile(data.resumeFile ? data.resumeFile : null);
        this.viewForm.setCoverLetter(data.coverLetter ? data.coverLetter : null);
        this.viewForm.setCoverLetterFile(data.coverLetterFile ? data.coverLetterFile : null);
        this.viewForm.setWrittenSample(data.writtenSample ? data.writtenSample : null);
        this.viewForm.setWrittenSampleFile(data.writtenSampleFile ? data.writtenSampleFile : null);
        this.viewForm.setImageSample(data.imageSample ? data.imageSample :null);
        this.viewForm.setImageSampleFiles(data.imageSampleFiles ? data.imageSampleFiles : []);
        this.viewForm.setAnswers(data.answers ? data.answers : null );
        this.viewForm.setWrittenSampleText(data.instructionText ? data.instructionText : null);
        this.viewForm.setBrandIcon(data.originalBrand.iconImage);
        this.viewForm.setAdditionalText(data.originalProfile.additionalText);
        this.viewForm.setPermissions(permissions);
        this.viewForm.setJobProfileImageUrl(data.originalProfile.imageUrl);
        this.viewForm.setJobProfileViewLink(window.location.origin+'/job/profiles/view/'+data.originalProfile.id);
        this.viewForm.setRejectionReasons(rejectionReasons); 
        
        this.setReferentialWork(data);
        this.setComments(data.comments)
        this.setInternalNotes(internalNotes)
        this.setStatus(data, permissions);
        this.setStatusClass(data);
        this.setHrStatus(data);
        this.setStatusResolved(data);
        this.setIsCandidate();
        this.setFilesIcon(data);
        this.countSteps(data);
        this.setApplicationHistory(applicationHistory);
        this.setOffboardingHistory(offboardingHistory);
        if(data.user){

            this.viewForm.setUserBrands(data.user.brands);
            this.viewForm.setCountry(data.user.valnet_user.country ? data.user.valnet_user.country.name : '')
            this.viewForm.setCandidateProfileLink(window.location.origin+'/users/profile/'+data.user.id)

            let roles = data.user.valnet_user.roles;
            let userRoles = "";
            for(let role of roles){

                userRoles = userRoles + role.name + ", ";
            }

            userRoles = userRoles.substring(0,  userRoles.length - 2);
            this.viewForm.setUserRoles(userRoles);
        }
    }

    protected setStatus(data, permissions){

        let status = data.applicationStatus;
        this.viewForm.setStatus(status);

        if(permissions['job_application_hr_flag'].write || permissions['job_application_status'].write) {

            if (data.applicationStatus.id == 2) {

                if (data.user) {
                    this.viewForm.setUserUpdatedStatus('By '+ data.user.valnet_user.fullName)
                }
                if (data.dateApplicationSubmitted) {
                    this.viewForm.setDateUpdatedStatus(data.dateApplicationSubmitted.substring(0, 16))
                }
            }

            if (data.applicationStatus.id > 2) {

                if (data.userUpdatedApplicationStatus) {
                    this.viewForm.setUserUpdatedStatus('By '+ data.userUpdatedApplicationStatus.valnet_user.fullName)
                }
                if (data.dateUpdateApplicationStatus) {
                    this.viewForm.setDateUpdatedStatus(data.dateUpdateApplicationStatus.substring(0, 16))
                }
            }
        }
    }

    protected setStatusClass(data){

        switch (data.applicationStatus.id){
            case 1:
                this.viewForm.setStatusClass('status status-pending icon i-pending');
                break;
            case 2:
                this.viewForm.setStatusClass('status status-submitted icon i-submitted');
                break;
            case 3:
                this.viewForm.setStatusClass('status status-approved icon i-approved');
                break;
            case 4:
                this.viewForm.setStatusClass('status status-rejected icon i-rejected');
                break;
            case 5:
                this.viewForm.setStatusClass('status status-cancel icon i-rejected');
                break;
            default:
                break;
        }
    }

    protected setHrStatus(data){

        this.viewForm.setHrStatus(data.hrStatus);

        if(data.userUpdatedHrStatus){
            this.viewForm.setUserUpdatedHrStatus('By '+ data.userUpdatedHrStatus.valnet_user.fullName)
        }
        if(data.dateUpdateHrStatus){
            this.viewForm.setDateUpdatedHrStatus(data.dateUpdateHrStatus.substring(0,16))
        }
    }

    public setReferentialWork(data){

        let referentialWork =  data.referentialWork;

        if(referentialWork){

            let links = referentialWork.links;

            if(links && links.length > 0){

                for (let key in links){

                    links[key] = (links[key] != '' && links[key].indexOf('://') === -1) ? 'https://' + links[key] : links[key];
                }
            }
            this.viewForm.setReferentialWork(referentialWork);
        }
    }

    protected setComments(comments){

        let date24HoursAgo = new Date();
        date24HoursAgo.setHours(date24HoursAgo.getHours() - 24);

        for(let comment of comments){
            let dateCreated = new Date(comment.dateCreated);

            //only allow comment delete if less than 24 hours old
            if (dateCreated < date24HoursAgo){
                comment.canDelete = false;
            }else{
                comment.canDelete = true;
            }
        }

        this.viewForm.setComments(comments);
    }

    protected setInternalNotes(internalNotes){

        for(let internalNote of internalNotes){

            internalNote.jobApplicationLink = window.location.origin +'/job/applications/view/' + internalNote.applicationId;
        }

        this.viewForm.setInternalNotes(internalNotes);
    }
    
    protected setApplicationHistory(applicationHistory){

        for(let application of applicationHistory){

            application.jobApplicationLink = window.location.origin +'/job/applications/view/' + application.applicationId;
        }

        this.viewForm.setApplicationHistory(applicationHistory);
    }  
    
    protected setOffboardingHistory(offboardingHistory){

        for(let offboarding of offboardingHistory){

            offboarding.articlesLink = window.location.origin +'/brand/'+offboarding.idBrand+'/articles/?authors=%5B%7B"id"%3A'+offboarding.idAuthor+'%2C"name"%3A"'+offboarding.userName+'"%7D%5D' ;
        }

        this.viewForm.setOffboardingHistory(offboardingHistory);
    }
    protected setStatusResolved(data) {

        // check if candidate status is resolved
        if(data.status.id == 3){

            this.viewForm.setStatusResolved(true);
            return;
        }

    }

    protected setFilesIcon(data){

        if(data.resumeFile){
            this.setFileIconClassName('resume', data.resumeFile);
        }

        if(data.coverLetterFile) {
            this.setFileIconClassName('coverLetter', data.coverLetterFile);
        }

        if(data.writtenSampleFile) {
            this.setFileIconClassName('writtenSample', data.writtenSampleFile);
        }

        if(data.imageSampleFiles){
            for (let i=0 ; i < data.imageSampleFiles.length; i++){
                this.setFileIconClassName('imageSample'+i, data.imageSampleFiles[i]);
            }
        }
    }

    private setFileIconClassName(key, data){

        let fileExtensions = ['jpg', 'jpeg', 'png', 'x-png', 'gif'];

        if (data.extension && fileExtensions.indexOf(data.extension) > -1) {
            this.viewForm.setFileIcon(key, 'i-image')
        } else {
            this.viewForm.setFileIcon(key, 'i-file')
        }
    }

    protected setIsCandidate(){

        let vnApp = this.getVnAppZone().app;

        if (vnApp.loggedUser != null && vnApp.loggedUser.isLoggedIn) {

            vnApp.loggedUser.user.valnet_user.roles.forEach((role) => {

                // check if has permission and application is new or submitted
                if(role.id == 20){

                    this.viewForm.setIsCandidate(true);
                    return;
                }
            })
        }
    }

    protected editApplication(id){

        page('/job/applications/edit/'+ id)
    }

    protected goBack(){

        let previousUrl = this.loadPreviousPage(window.location.href);
        if(previousUrl){
            page.redirect(previousUrl);
        }else{
            page.redirect('/job/applications');
        }
    }

    protected updateStatus(value){

        this.loadingIn(this.viewForm.builtTemplate);

        let formReq_url: string = '/api/job/applications/status/update/';
        let formReq_params: Array<Array<string>> = [];

        let rejectionReason = this.viewForm.getTemplateViewModel().selectedReason();

        let data = {
            id: this.viewForm.getTemplateViewModel().id(),
            idFlag: value,
            rejectionReason: (rejectionReason ? rejectionReason : null),
        }

        formReq_params.push(["data", ko.toJSON(data)]);
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let msg = (value == '4' ? 'Application Rejected !' : (value == '5' ? 'Application Canceled !' : 'Application Approved !'))
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, msg);

                    obj.goBack();
                });
                obj.loadingOut(obj.viewForm.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    protected updateHrStatus(value){

        this.loadingIn(this.viewForm.builtTemplate);

        let formReq_url: string = '/api/job/applications/hrStatus/update/';
        let formReq_params: Array<Array<string>> = [];

        let rejectionReason = this.viewForm.getTemplateViewModel().selectedReason();

        let data = {
            id: this.viewForm.getTemplateViewModel().id(),
            idFlag: value,
            rejectionReason: (rejectionReason ? rejectionReason : null),
        }

        formReq_params.push(["data", ko.toJSON(data)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "HR Status changed successfully !");

                    obj.goBack();
                });
                obj.loadingOut(obj.viewForm.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    protected addComment(isInternal){

        let formReq_url: string = '/api/job/applications/comments/save/';
        let formReq_params: Array<Array<string>> = [];

        let value = '';
        if(isInternal){
            value = this.viewForm.getTemplateViewModel().internalNote();
            this.loadingIn(this.viewForm.builtTemplate.querySelector('#internal-notes'));
        }else{
            value = this.viewForm.getTemplateViewModel().comment();
            this.loadingIn(this.viewForm.builtTemplate.querySelector('#external-comments'));
        }

        let subViewModel = {id: this.viewForm.getTemplateViewModel().id(), comment: value, 'isInternal': isInternal}
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let responseParsed = JSON.parse(req.request.response);
                    obj.updateCommentsAndInternalNotes(responseParsed.data);
                    if(isInternal){
                        obj.loadingOut(obj.viewForm.builtTemplate.querySelector('#internal-notes'));
                    }else {
                        obj.loadingOut(obj.viewForm.builtTemplate.querySelector('#external-comments'));
                    }
                });
            }
        });
        XHRHdl.execute();
    }

    protected deleteComment(data, isInternal){

        if(isInternal){
            this.loadingIn(this.viewForm.builtTemplate.querySelector('#internal-notes'));
        }else{
            this.loadingIn(this.viewForm.builtTemplate.querySelector('#external-comments'));
        }

        let formReq_url: string = '/api/job/applications/comments/delete/' + data.id;
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = {'isInternal': isInternal}
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let responseParsed = JSON.parse(req.request.response);
                    obj.updateCommentsAndInternalNotes(responseParsed.data);
                    if(isInternal){
                        obj.loadingOut(obj.viewForm.builtTemplate.querySelector('#internal-notes'));
                    }else {
                        obj.loadingOut(obj.viewForm.builtTemplate.querySelector('#external-comments'));
                    }
                });
            }
        });
        XHRHdl.execute();
    }

    protected updateCommentsAndInternalNotes(data){

        this.setComments(data.comments)
        this.setInternalNotes(data.internalNotes)
        this.viewForm.getTemplateViewModel().comment('')
        this.viewForm.getTemplateViewModel().internalNote('');
    }

    protected downloadFile(path, name){

        let link = document.createElement('a');
        link.href = path;
        //here you append your rootURL to the file name
        link.download = name;
        document.body.appendChild(link);
        link.click();
    }

    private jobQuestionRequiresAnswer(id: any): boolean {
        const n = Number(id);
        return REQUIRED_QUESTION_IDS.indexOf(n) !== -1;
    }

    private isAnswerProvidedRaw(d: any): boolean {
        const at = (d.answerType || d.answer_type || 'text').toString().toLowerCase();
        let ans = d.answer;
        if (at === 'checkbox') {
            if (typeof ans === 'string') {
                const t = ans.trim();
                if (t.indexOf('[') === 0) {
                    try {
                        ans = JSON.parse(t);
                    } catch (e) {
                        /* keep string */
                    }
                }
            }
            if (Array.isArray(ans)) {
                return ans.filter(function (x) { return x !== null && x !== ''; }).length > 0;
            }
            return false;
        }
        return ans != null && ans !== '' && String(ans).trim() !== '';
    }

    protected countSteps(data) {

        let stepsDetails = [] ;
        let keys = ['files', 'referentialWork', 'writtenSample', 'imageSample', 'answers']

        for (let key of keys) {

            let step = { total : 0, required: 0, completed : 0, current : 0};
            step = this.updateStepDetails(key, data, step);

            //check completed ones
            if(step.total > 0 && step.completed >= step.required){
                this.viewForm.getTemplateViewModel().stepsCompleted(this.viewForm.getTemplateViewModel().stepsCompleted() + 1);
            }

            step.current = this.viewForm.getTemplateViewModel().totalSteps();
            stepsDetails[key] = step;
        }
        this.viewForm.setStepsDetails(stepsDetails);
    }

    private updateStepDetails(key, data, step){

        if(!data){
            return ;
        }

        switch (key){
            case 'files':
                if((data.resume && data.resume.id > 1) || (data.coverLetter && data.coverLetter.id > 1)) {
                    this.viewForm.getTemplateViewModel().totalSteps(this.viewForm.getTemplateViewModel().totalSteps() + 1);
                    if (data.resume.id > 1) {
                        step.total++
                        if (data.resume.id == 2 || data.resume.id == 3) {
                            step.required++
                        }
                        if (data.resume.path != '') {
                            step.completed++;
                        }
                    }
                    if (data.coverLetter.id > 1) {
                        step.total++
                        if (data.coverLetter.id == 2 || data.coverLetter.id == 3) {
                            step.required++
                        }
                        if (data.coverLetter.path != '') {
                            step.completed++;
                        }
                    }
                }
            return step;
            case 'writtenSample':
                if(data.writtenSample && data.writtenSample.id > 1) {
                    this.viewForm.getTemplateViewModel().totalSteps(this.viewForm.getTemplateViewModel().totalSteps() + 1);
                    step.total++
                    if (data.writtenSample.id == 2 || data.writtenSample.id == 3) {
                        step.required++;
                    }
                    if (data.writtenSample.path != '' || data.instructionText) {
                        step.completed++;
                    }
                }
                return step;
            case 'referentialWork':
                if(data.referentialWork && data.referentialWork.id > 1) {
                    this.viewForm.getTemplateViewModel().totalSteps(this.viewForm.getTemplateViewModel().totalSteps() + 1);
                    step.total = 3
                    if (data.referentialWork.id == 2 || data.referentialWork.id == 3) {
                        step.required++;
                    }
                    if (data.referentialWork.links && data.referentialWork.links.length > 0) {
                        for (let link of data.referentialWork.links) {
                            if (link != '') {
                                step.completed++
                            };
                        }
                    }
                }
                return step;
            case 'imageSample':
                if(data.imageSample && data.imageSample.id > 1) {
                    this.viewForm.getTemplateViewModel().totalSteps(this.viewForm.getTemplateViewModel().totalSteps() + 1);
                    step.total = 3
                    if (data.imageSample.id == 2 || data.imageSample.id == 3) {
                        step.required++;
                    }
                    if (data.imageSample.path && data.imageSample.path.length > 0) {
                        for (let path of data.imageSample.path) {
                            if (path != '') {
                                step.completed++
                            };
                        }
                    }
                }
                return step;
            case 'answers':
                if(data.answers && data.answers.length > 0){
                    this.viewForm.getTemplateViewModel().totalSteps(this.viewForm.getTemplateViewModel().totalSteps() + 1);
                    step.total = data.answers.length;
                    for(let d of data.answers) {
                        if(this.jobQuestionRequiresAnswer(d.id)){
                            step.required++
                            if(this.isAnswerProvidedRaw(d)){
                                step.completed++
                            }
                        }
                    }
                }
                return step;
            default:
                break;
        }
    }

}


// WEBPACK FOOTER //
// ./js/modules/job_applications_view.ts